import {cn} from '@chekinapp/ui';

const EMAIL_PLACEHOLDER = 'name@email.com';

const PROPERTY_LINK_ROOT_CLASSES = cn(
  'relative flex min-h-[var(--app-dvh,100dvh)] w-full flex-col bg-white desk:bg-[var(--chekin-color-brand-navy)] tab:bg-[var(--chekin-color-brand-navy)]',
  '[--chekin-color-gray-1:var(--chekin-neutral-650)] [--chekin-text-secondary:var(--chekin-neutral-650)]',
);

export {EMAIL_PLACEHOLDER, PROPERTY_LINK_ROOT_CLASSES};
